export class Vendor {
  id?: number | null;
  name?: string | null;

  constructor(dto?: Partial<Vendor>) {
    Object.assign(this, dto);
  }
}
